module.exports = __webpack_public_path__ + "img/right-chevron.41e4ce9d.svg";